<template>
  <div v-if="currentCourse">
    <h3 class="display-1 mb-4"><span class="mr-2"><i class="fas fa-chalkboard"></i></span> {{ title }}</h3>
    <p>Da questo ambiente puoi completare le informazioni riguardanti la didattica in fase 3 descritte nella pagina <em>Didattica in tempo di Covid-19</em> del menu Studenti.</p><p>Di  seguito, compila le indicazioni <strong>per ogni anno del corso</strong>:</p><ol><li>dal menu a tendina scegli quale tipo di didattica sarà adottata: <em> a distanza</em>, <em>in presenza</em> o <em>mista</em></li><li> descrivi le indicazioni generali per la didattica nel primo campo di testo</li><li>se appropriato, aggiungi dettagli sullo svolgimento delle attività di laboratorio nel secondo campo di testo</li></ol><br><p>Se le indicazioni sono valide per gli anni successivi, attiva il comando <em>acceso/spento</em> relativo</p>
    <v-expansion-panel
      v-model="panel"
      expand
    >
      <v-expansion-panel-content
        v-for="(year, i) in yearsData"
        :key="i"
        :disabled="enabledYears.length > 0 && !enabledYears[i]"
        >
        <template v-slot:header>
          <v-flex grow>
          <h4>{{year.label}}</h4>
          </v-flex>
          <v-flex shrink class="mr-5">
          <span v-if="enabledYears.length && !enabledYears[i]">
            <span v-if="federatedYear">Valgono le indicazioni del {{federatedYear}} anno</span>
            <span v-else>Valgono le indicazioni precedenti</span>
          </span>
          <v-switch
            v-else-if="!(yearsData && i === yearsData.length - 1)"
            :input-value="year.validForNextYears"
            @change="year.validForNextYears = !year.validForNextYears; calcEnabledYears()"
            @click.native.stop
            label="Indicazioni valide anche per tutti gli anni successivi"
          ></v-switch>
          </v-flex>
        </template>
        <v-card>
          <v-card-text class="grey lighten-3">
            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs12 md6 xl4>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-select
                        class="mb-2"
                        :items="teachingTypes"
                        v-model="year.type"
                        :rules="[$validate.required]"
                        label="Modalità di erogazione della didattica *"
                        item-text="text"
                        item-value="value"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md6 lg6 xl4>
                  <v-stepper light non-linear v-model="steps[i]">
                    <v-stepper-header>
                      <v-stepper-step editable :step="1">{{userPrimaryLang.text}}</v-stepper-step>
                      <v-divider></v-divider>
                      <v-stepper-step editable v-if="!userHasOnlyOneLang" :step="2" @click.native="translateStep(userPrimaryLang.value, userSecondaryLang.value)">{{userSecondaryLang.text}}</v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-items>
                      <v-stepper-content step="1">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <editor
                              class="mt-4 mb-1"
                              label="Indicazioni generali per la didattica"
                              v-model="year.details[userPrimaryLang.value]"
                            />
                            <p v-if="!userHasOnlyOneLang && year.details[userSecondaryLang.value]" class="mt-1">
                              <a href="" @click.prevent="translateProp(i, 'details', userSecondaryLang.value, userPrimaryLang.value)"><code class="info--text">Aggiorna traduzione da {{userSecondaryLang.text}}</code></a>
                            </p>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <editor
                              class="mt-4 mb-1"
                              label="Indicazioni per attività di laboratorio/pratica"
                              v-model="year.labs[userPrimaryLang.value]"
                            />
                            <p v-if="!userHasOnlyOneLang && year.labs[userSecondaryLang.value]" class="mt-1">
                              <a href="" @click.prevent="translateProp(i, 'labs', userSecondaryLang.value, userPrimaryLang.value)"><code class="info--text">Aggiorna traduzione da {{userSecondaryLang.text}}</code></a>
                            </p>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-btn
                              color="primary"
                              @click="nextStep(i)"
                              v-if="!userHasOnlyOneLang"
                            >
                              Avanti
                              <v-icon>chevron_right</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-stepper-content>
                      <v-stepper-content v-if="!userHasOnlyOneLang" step="2">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <editor
                              class="mt-4 mb-1"
                              label="Indicazioni generali per la didattica"
                              v-model="year.details[userSecondaryLang.value]"
                            />
                            <p v-if="!userHasOnlyOneLang && year.details[userPrimaryLang.value]" class="mt-1">
                              <a href="" @click.prevent="translateProp(i, 'details', userPrimaryLang.value, userSecondaryLang.value)"><code class="info--text">Aggiorna traduzione da {{userPrimaryLang.text}}</code></a>
                            </p>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <editor
                              class="mt-4 mb-1"
                              label="Indicazioni per attività di laboratorio/pratica"
                              v-model="year.labs[userSecondaryLang.value]"
                            />
                            <p v-if="!userHasOnlyOneLang && year.labs[userPrimaryLang.value]" class="mt-1">
                              <a href="" @click.prevent="translateProp(i, 'labs', userPrimaryLang.value, userSecondaryLang.value)"><code class="info--text">Aggiorna traduzione da {{userPrimaryLang.text}}</code></a>
                            </p>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-btn
                              color="primary"
                              @click="prevStep(i)"
                            >
                              <v-icon>chevron_left</v-icon> Indietro
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-stepper-content>
                    </v-stepper-items>
                  </v-stepper>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-layout row wrap class="mt-4">
      <v-flex xs12 class="text-xs-right">
        <v-btn color="primary" @click="checkTranslationAndSave()">Salva</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import _ from 'lodash'
import { $cloudinaryUrl } from '@/mixins/cloudinary'
import editor from '@/components/common/Editor'
import { $EventBus } from '@/eventBus'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      title: 'Didattica Covid-19',
      panel: [],
      yearsLabel: ['Primo', 'Secondo', 'Terzo', 'Quarto', 'Quinto', 'Sesto'],
      yearsData: [],
      enabledYears: [],
      steps: {},
      federatedYear: '',
      teachingTypes: [{
        text: 'A distanza',
        value: 'esclusivamente-a-distanza'
      }, {
        text: 'In presenza',
        value: 'esclusivamente-in-presenza'
      }, {
        text: 'Misto',
        value: 'misto'
      }],
      langs: [{
        value: 'it',
        text: 'Italiano'
      },
      {
        value: 'en',
        text: 'Inglese'
      }]
    }
  },
  computed: {
    ...mapGetters({
      currentCourse: 'courses/currentCourse'
    }),
    menu () {
      return {
        header: {
          image: this.currentCourse ? this.currentCourse.immagine : undefined
        },
        items: [
          {
            title: 'Didattica Covid-19',
            icon: 'fas fa-chalkboard',
            route: { name: 'course' }
          }
        ]
      }
    },
    userHasOnlyOneLang () {
      return this.$user.langs.length === 1
    },
    userPrimaryLang () {
      return this.langs.find((l) => l.value === this.$user.default_lang)
    },
    userSecondaryLang () {
      return this.langs.find((l) => l.value !== this.$user.default_lang)
    }
  },
  methods: {
    calcEnabledYears () {
      this.enabledYears = this.yearsData.map((v, i) => !(_.find(_.take(this.yearsData, i), 'validForNextYears')))
      this.federatedYear = _.get(this.yearsLabel, this.enabledYears.indexOf(false) - 1, undefined)
      if (this.federatedYear) {
        this.federatedYear = _.lowerCase(this.federatedYear)
      }
    },
    nextStep (index) {
      if (!this.steps[index]) {
        this.steps[index] = 1
      }
      if (this.steps[index] < 2) {
        this.translateStep(this.userPrimaryLang.value, this.userSecondaryLang.value).then(this.steps[index] += 1)
      }
    },
    prevStep (index) {
      if (this.steps[index] > 1) {
        this.steps[index] -= 1
      }
    },
    translateStep (sourceLang, targetLang) {
      return new Promise((resolve, reject) => {
        const sourceObj = this.yearsData
        const propsToTranslate = ['details', 'labs']
        const valuesToTranslate = _.reduce(Array.from({ length: this.yearsData.length }), (a, v, i) => {
          _.each(propsToTranslate, p => {
            // genero la path delle property da tradurre e ottengo il valore
            const propSourcePath = `[${i}].${p}.${sourceLang}`
            const propTargetPath = `[${i}].${p}.${targetLang}`
            const sourceValue = _.get(this.yearsData, propSourcePath, '')
            const targetValue = _.get(this.yearsData, propTargetPath, '')
            if (sourceValue !== '' && (!this.userHasOnlyOneLang ? targetValue === '' : true)) { // solo quelle inserite e non ancora tradotte se ha due linggue, se ne ha una sola sempre
              a.push({ prop: propSourcePath, value: sourceValue })
            }
          })
          return a
        }, [])
        if (valuesToTranslate.length) {
          this.$http('/google/translate', {
            method: 'POST',
            data: {
              texts: valuesToTranslate,
              source_lang: sourceLang.toUpperCase(), // 'IT'
              target_lang: targetLang.toUpperCase()
            }
          }) // aggiorna le prop tradotte
            .then((result) => {
              result.data.props.forEach((p, i) => {
                const { groups: segments } = /\[(?<index>[0-9]*)\]\.(?<property>.*)\.(?<language>.*)/.exec(p)
                console.log(segments)
                this.$set(sourceObj[segments.index][segments.property], targetLang, result.data.translations[i].text)
                resolve()
              })
            })
            .catch((err) => {
              $EventBus.$emit('message', { type: 'error', text: 'Errore durante la traduzione automatica dello step' })
              console.log('err', err)
              reject(err)
            })
        } else {
          // niente da tradurre
          resolve()
        }
      })
    },
    translateProp (index, prop, sourceLang, targetLang) {
      const sourceObj = this.yearsData[index]
      this.$http('/google/translate', {
        method: 'POST',
        data: {
          texts: [{
            prop: prop,
            value: sourceObj[prop][sourceLang]
          }],
          source_lang: sourceLang.toUpperCase(), // 'IT'
          target_lang: targetLang.toUpperCase()
        }
      }) // aggiorna le prop tradotte
        .then((result) => {
          const translation = result.data.translations[0].text
          this.$set(this.yearsData[index][prop], targetLang, translation)
          console.log(translation)
          $EventBus.$emit('message', { type: 'success', text: 'Traduzione aggiornata' })
        })
        .catch((err) => {
          $EventBus.$emit('message', { type: 'error', text: 'Errore durante la traduzione del campo' })
          console.log('err', err)
        })
    },
    checkTranslationAndSave () {
      this.translateStep(this.userPrimaryLang.value, this.userSecondaryLang.value).then(() => this.save())
    },
    save () {
      const that = this
      this.$http('/db/erogazione-didattica', {
        method: 'PUT',
        data: {
          tenant: this.currentCourse.codice,
          anni: this.yearsData
        }
      })
        .then((result) => {
          let yearsData = result.data.anni
          if (!yearsData.length) {
            yearsData = Array.from({ length: this.currentCourse.durata }).map((v, i) => ({ anno: i, label: _.get(this.yearsLabel, i, i + 1) + ' anno', validForNextYears: false, type: undefined, details: { it: '', en: '' }, labs: { it: '', en: '' } }))
          }
          that.$set(this, 'yearsData', yearsData)
          that.calcEnabledYears()
          $EventBus.$emit('message', { type: 'success', text: 'Informazioni salvate' })
        })
        .catch((err) => {
          $EventBus.$emit('message', { type: 'error', text: 'Errore durante il caricamento delle informazioni erogazione didattica' })
          console.log('err', err)
        })
    }
  },
  components: {
    editor
  },
  mounted () {
    const that = this
    this.$http('/db/erogazione-didattica', {
      method: 'GET',
      params: {
        tenant: this.currentCourse.codice
      }
    })
      .then((result) => {
        let yearsData = result.data.anni
        if (!yearsData.length) {
          yearsData = Array.from({ length: this.currentCourse.durata }).map((v, i) => ({ anno: i, label: _.get(this.yearsLabel, i, i + 1) + ' anno', validForNextYears: false, type: undefined, details: { it: '', en: '' }, labs: { it: '', en: '' } }))
        }
        that.$set(this, 'yearsData', yearsData)
        that.calcEnabledYears()
      })
      .catch((err) => {
        $EventBus.$emit('message', { type: 'error', text: 'Errore durante il caricamento delle informazioni erogazione didattica' })
        console.log('err', err)
      })
  },
  mixins: [$cloudinaryUrl]
}
</script>
